import React from "react";
import { Outlet, Route, Routes, useLocation } from "react-router-dom";
import Reception from "./detail/reception";
import Hotdesk from "./detail/hotdesk";
import Videoconference from "./detail/videoconference";
import Conference from "./detail/conference";
import Main from "./detail/main";

import style from "css/workspace.module.css";
import deviceStyle from "css/device.module.css";
import Platform from "./detail/platform";
import Presentation from "./detail/presentation";
import ClickShare from "components/device/thirdParty/clickShare";

function WorkspaceMain() {
  return (
    <div className={style.fontsize}>
      <Routes>
        <Route path="reception" element={<Reception />} />
        <Route path="hotdesk" element={<Hotdesk />} />

        <Route path="videoconference">
          <Route
            path="individual"
            element={<Videoconference status="individual" />}
          />
          <Route path="small" element={<Videoconference status="small" />} />
          <Route path="large" element={<Videoconference status="large" />} />
          <Route path="lounge" element={<Videoconference status="lounge" />} />
          {/* 기본 값 */}
          <Route index element={<Videoconference status="individual" />} />
        </Route>

        <Route path="conference" element={<Conference />} />
        <Route path="platform" element={<Platform />} />
        <Route path="presentation" element={<Presentation />} />
        {/* <Route
          path="presentation"
          element={
            <div className={deviceStyle.device_popup_wrapper}>
              <ClickShare />
            </div>
          }
        /> */}

        {/* 다른 모든 경로 */}
        <Route path="*" element={<Main />} />
      </Routes>
    </div>
  );
}

export default WorkspaceMain;
